import React, { useState } from 'react';
import { Typography, IconButton, Popover } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { InfoOutlined } from '@mui/icons-material';


const InfoPopover = ({ content, width, height, text, margin, padding} ) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Typography
        variant="subtitle2"
        align="left"
        gutterBottom
        component="div"
      >
        {text}
      </Typography>
      <IconButton
        aria-describedby={id}
        onClick={handleClick}
        size="medium"
        style={{ margin }}
      >
        <InfoOutlined fontSize='small' style={{ color: 'black' }} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{ 
          '& .MuiPaper-root': {
            backgroundColor: 'white',
            color: 'black',
            width: width || '150px',
            height: height || '150px',
            borderWidth: '0.5px',
            borderStyle: 'solid',
            borderColor: 'lightgrey',
            padding:padding || '0px',
          },
        }}
      >
        <Typography sx={{ p: 2 }}>{content}</Typography>
      </Popover>
    </div>
  );
};

export default InfoPopover;